import { Skeleton } from "@/components/ui/skeleton";

const LegalPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Warning Banner */}
      <div className="h-10 bg-muted" />
      
      {/* Navigation */}
      <div className="h-16 border-b border-border" />
      
      <main className="container mx-auto px-4 py-8">
        {/* Breadcrumbs */}
        <div className="flex items-center gap-2 mb-6">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-40" />
        </div>

        {/* Hero Section */}
        <div className="text-center mb-12">
          <Skeleton className="h-10 w-2/3 mx-auto mb-4" />
          <Skeleton className="h-5 w-48 mx-auto" />
        </div>

        {/* Content Container */}
        <div className="max-w-4xl mx-auto">
          {/* Section 1 */}
          <div className="mb-10">
            <Skeleton className="h-7 w-48 mb-4" />
            <div className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-4/5" />
            </div>
          </div>

          {/* Section 2 */}
          <div className="mb-10">
            <Skeleton className="h-7 w-56 mb-4" />
            <div className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-full" />
            </div>
            {/* List Items */}
            <div className="mt-4 space-y-2 pl-6">
              <div className="flex items-start gap-2">
                <Skeleton className="h-2 w-2 rounded-full mt-2" />
                <Skeleton className="h-4 flex-1" />
              </div>
              <div className="flex items-start gap-2">
                <Skeleton className="h-2 w-2 rounded-full mt-2" />
                <Skeleton className="h-4 flex-1" />
              </div>
              <div className="flex items-start gap-2">
                <Skeleton className="h-2 w-2 rounded-full mt-2" />
                <Skeleton className="h-4 flex-1" />
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="mb-10">
            <Skeleton className="h-7 w-64 mb-4" />
            <div className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          </div>

          {/* Section 4 */}
          <div className="mb-10">
            <Skeleton className="h-7 w-52 mb-4" />
            <div className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-4/5" />
            </div>
          </div>

          {/* Section 5 */}
          <div className="mb-10">
            <Skeleton className="h-7 w-44 mb-4" />
            <div className="space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-card rounded-xl border border-border p-6 mb-10">
            <Skeleton className="h-6 w-40 mb-4" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-64" />
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-4 w-56" />
            </div>
          </div>

          {/* Last Updated */}
          <div className="text-center">
            <Skeleton className="h-4 w-48 mx-auto" />
          </div>
        </div>
      </main>

      {/* Footer */}
      <div className="bg-muted py-12 mt-12">
        <Skeleton className="h-40 max-w-6xl mx-auto" />
      </div>
    </div>
  );
};

export default LegalPageSkeleton;
